import React from 'react'

export default function DesktopCheck() {
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.7889 7.14282H3.57136C2.58514 7.14282 1.78564 7.94232 1.78564 8.92854V37.5C1.78564 38.486 2.58514 39.2857 3.57136 39.2857H46.4285C47.4146 39.2857 48.2142 38.486 48.2142 37.5V19.9525" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21.4286 39.2858L17.8572 48.2143" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M28.5713 39.2858L32.1427 48.2143" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.2856 48.2142H35.7142" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M28.5713 11.2479L35.7141 16.605L48.2141 2.31934" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
